<template>
  <el-row
    style="height: 80px;"
    :gutter="$gutter"
    type="flex"
    justify="end"
    align="middle"
  >
    <el-col :span="12">
      <router-link to="/">
        <img
          class="logo"
          alt="Owiwi"
          title="Owiwi"
          src="~assets/icons/logo.png"
          srcset="~assets/icons/logo@2x.png 2x, ~assets/icons/logo@3x.png 3x"
        >
      </router-link>
    </el-col>
    <el-col
      :span="12"
      class="flex align-center justify-flex-end"
    >
      <span> Hello <strong>{{ userName }}!</strong></span>
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: 'UserHeader',
  computed: {
    userName() {
      return this.$store.getters.getUserFirstName
    }
  }
}
</script>
